export default "__VITE_ASSET__DxhYhtD9__"